/**
 * Exp Header JS — burger, disclosures, sticky fallback.
 */
(function () {
  const root = document.querySelector('.exp-header');
  if (!root) return;

  // Burger (mobile)
  const burger = root.querySelector('.exp-burger');
  const panel = document.getElementById('exp-mobile');
  if (burger && panel) {
    burger.addEventListener('click', () => {
      const opened = !panel.hasAttribute('hidden');
      if (opened) {
        panel.setAttribute('hidden', '');
        burger.setAttribute('aria-expanded', 'false');
      } else {
        panel.removeAttribute('hidden');
        burger.setAttribute('aria-expanded', 'true');
      }
    });
    const closeBtn = panel.querySelector('.exp-mobile__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        panel.setAttribute('hidden', '');
        burger.setAttribute('aria-expanded', 'false');
      });
    }
    panel.addEventListener('click', (e) => {
      if (e.target === panel) {
        panel.setAttribute('hidden', '');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Mobile disclosures
  root.addEventListener('click', (e) => {
    const btn = e.target.closest('.exp-mnav__chev');
    if (!btn) return;
    const id = btn.getAttribute('aria-controls');
    const target = id && document.getElementById(id);
    if (!target) return;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    if (expanded) { target.setAttribute('hidden', ''); } else { target.removeAttribute('hidden'); }
  });

  // Desktop: split/toggle disclosures (open on click)
  root.addEventListener('click', (e) => {
    const discl = e.target.closest('[data-exp-disclosure]');
    if (!discl) return;
    const controls = discl.getAttribute('aria-controls');
    const panelEl = controls && document.getElementById(controls);
    if (!panelEl) return;
    const expanded = discl.getAttribute('aria-expanded') === 'true';
    discl.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    if (expanded) { panelEl.setAttribute('hidden', ''); } else { panelEl.removeAttribute('hidden'); }
  });

  // Sticky fallback (if mode = fixed)
  const mode = root.getAttribute('data-sticky-mode');
  if (mode === 'fixed') {
    const top = parseInt(getComputedStyle(root).getPropertyValue('--exp-offset-top')) || 0;
    const sentry = document.createElement('div');
    sentry.style.position = 'absolute';
    sentry.style.top = '0';
    sentry.style.left = '0';
    sentry.style.width = '1px';
    sentry.style.height = '1px';
    root.parentNode.insertBefore(sentry, root);

    const onScroll = () => {
      const y = window.scrollY || window.pageYOffset;
      if (y > top) {
        root.style.position = 'fixed';
        root.style.top = top + 'px';
        root.style.left = '0';
        root.style.right = '0';
      } else {
        root.style.position = '';
        root.style.top = '';
        root.style.left = '';
        root.style.right = '';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();